import React from "react";
import eventRefs from "../../../assets/eventRef";
import { Link } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";
import LoadingSpinner from '../../../components/common/loading'


export default class DeviceAlerts extends React.Component {
  state = {
    searchBar: "",
    currentFilter: "",
    eventNameFilter: "",
    eventTriggeredFilter: "",
    sortFilter: "",

    refreshing: new Set(),
  };
  applyFilters = () => {
    this.setState({
      currentFilter: this.state.searchBar,
    });
  };
  componentDidMount() {


  }


  refreshEvent = (enclosureSerialNumber, _eventId) => {
    if (this.state.refreshing.has(enclosureSerialNumber)) return;

    // 1️⃣ mark “in progress”
    this.setState(prev => ({
      refreshing: new Set(prev.refreshing).add(enclosureSerialNumber)
    }));

    const refreshEvents = this.props.refreshEvents;
    if (!refreshEvents) {
      this.setState(prev => {
        const next = new Set(prev.refreshing);
        next.delete(enclosureSerialNumber);
        return { refreshing: next };
      });
      return;
    }

    refreshEvents({ serial: enclosureSerialNumber, force: true })
      .catch((err) => {
        console.error("Failed to refresh events", err);
      })
      .finally(() => {
        this.setState(prev => {
          const next = new Set(prev.refreshing);
          next.delete(enclosureSerialNumber);
          return { refreshing: next };
        });
      });


  }
  render() {
    const {
      events,
      loading: eventsLoading,
      deviceOffline,
      offlineReason,

      // devices

    } = this.props;

    const sortedEvents = [
      ...events.filter((e) => e.triggered),
      ...events.filter((e) => !e.triggered),
    ];

    const filteredSortedEvents = sortedEvents.filter((event) => {
      const foundEventRef =
        eventRefs.find((er) => er.code === event.code) || {};
      const eventRefName = foundEventRef.name;
      const eventParameters = (event.params || []).join("");
      if (this.state.eventNameFilter) {
        if (this.state.eventNameFilter != eventRefName) {
          return false;
        }
      }
      if (this.state.eventTriggeredFilter) {
        if (this.state.eventTriggeredFilter === "OK" && event.triggered) {
          return false;
        }
        if (this.state.eventTriggeredFilter === "Alert" && !event.triggered) {
          return false;
        }
      }

      return `${eventRefName}${event.name}${event.enclosureSerialNumber}${(event.deviceName || "")}${eventParameters}`
        .toLowerCase()
        .includes(this.state.currentFilter.toLowerCase());
    });

    let finalFilteredSortedEvents = filteredSortedEvents;

    const eventNameOptions = sortedEvents.reduce((sum, item) => {
      let foundEventRefName = eventRefs.find(
        (er) => er.code === item.code
      )?.name;
      if (foundEventRefName) {
        if (!sum.includes(foundEventRefName)) {
          sum.push(foundEventRefName);
        }
      }
      return sum;
    }, []);

    const columnWidths = [
      9, //0
      16, //1
      4, //2
      6, //3
      4, //4
      5, //5
      9, //6
      15, //7
      7, //8
    ];
    return (
      <div
        style={{
          overflowX: "auto",
        }}
      >
        <div
          className="grid-x"
          style={{ marginBottom: "10px", marginTop: "20px" }}
        >
          <div className="cell show-for-small-only">
            {this.props.match.params.enclosureSerialNumber ? (
              <div className="">
                <div
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <Link
                    to={`/devices/connected/${this.props.match.params.enclosureSerialNumber}/alerts/new`}
                  >
                    <div
                      className="button"
                      style={{
                        marginBottom: "10px",
                        width: "100%",
                      }}
                    >
                      <span>+ Create New Alert Event</span>
                    </div>
                  </Link>
                </div>
              </div>
            ) : (
              null
            )}
          </div>

          <div className="cell ">
            {this.props.match.params.enclosureSerialNumber ? (
              <div
                className=""
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    width: "300px",
                    // padding: "10px"
                  }}
                >
                  <div>
                    <Link
                      to={`/devices/connected/${this.props.match.params.enclosureSerialNumber}/alerts/new`}
                    >
                      <div
                        className="button"
                        style={{
                          marginBottom: "0px",
                        }}
                      >
                        <span>+ Create New Alert Event</span>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              null
            )}
          </div>
        </div>
        <div className="grid-x">
          <div className="cell large-6">
            <div
              style={{
                fontSize: "14px",
                color: "#6b6b6b",
                marginBottom: "5px",
                marginLeft: "3px",
              }}
            >
              Filter by
            </div>
            <div
              style={{
                display: "flex",
                marginBottom: "20px",
              }}
            >
              <span
                style={{
                  marginRight: "10px",
                }}
              >
                <select
                  style={{
                    margin: "0px",
                  }}
                  onChange={(e) => {
                    this.setState({
                      eventNameFilter: e.target.value,
                    });
                  }}
                >
                  <option value="">All Event Types</option>
                  <optgroup label="Filter by">
                    {eventNameOptions.map((name) => {
                      return (
                        <option key={name} value={name}>
                          {name}
                        </option>
                      );
                    })}
                  </optgroup>
                </select>
              </span>
              <span>
                <select
                  style={{
                    // backgroundColor: "transparent",
                    // border: "none",
                    // cursor: 'pointer',
                    margin: "0px",
                    // color: "#6b6b6b",
                    // fontSize: "14px",
                  }}
                  onChange={(e) => {
                    this.setState({
                      eventTriggeredFilter: e.target.value,
                    });
                  }}
                  value={this.state.eventTriggeredFilter}
                >
                  <option value="">All Status</option>
                  <optgroup label="Filter by">
                    <option value="OK">OK (Normal)</option>
                    <option value="Alert">Alert Activated</option>
                  </optgroup>
                </select>
              </span>
            </div>
          </div>
          <div className="cell large-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
            <Link to="/alerts-documentation">

              <div className="button" style={{ display: 'flex', alignItems: 'center', margin: "0px", backgroundColor: "#eee", color: "#333"}}>
              <i className="material-icons">help</i>
                <div style={{ color: "#333" }}>
                  Learn More about Alerts
                </div>
              </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="grid-row header">
          {/* <div style={{ flex: columnWidths[0] }}>Category</div> */}
          <div style={{ flex: columnWidths[1] }}>Event Name</div>
          <div style={{ flex: columnWidths[2] }}>
            Status
          </div>
          <div style={{ flex: columnWidths[6] }}>Last Triggered</div>
          <div style={{ flex: columnWidths[7] }}>Details</div>
          {/* <div style={{ flex: columnWidths[7] }}>PDU</div> */}
        </div>
        {eventsLoading ? (
          <Loading columnWidths={columnWidths} />
        ) : sortedEvents.length === 0 ? (
          <div className="grid-row-wrapper">
            <div className="grid-row">
              <div style={{ paddingLeft: "30px" }}>No Events Found</div>
            </div>
          </div>
        ) : null}
        {finalFilteredSortedEvents.map((event, index) => {
          const foundEventRef =
            eventRefs.find((er) => er.code === event.code) || {};

          const eventRefName = foundEventRef.name;
          const foundEventRefDescription = event
            ? event.triggered
              ? foundEventRef?.triggeredDescription
              : foundEventRef?.notTriggeredDescription
            : "";
          const hydratedFoundEventRefDesc = (foundEventRefDescription || "").replace(
            /{{param(\d+)}}/g,
            (_, i) => {
            const idx = parseInt(i, 10) - 1;
              const rawVal = (event?.params || [])[idx] ?? "";
              if (event?.code === 12 && idx === 2) {
                if (rawVal === "1" || rawVal === 1) return "primary ethernet";
                if (rawVal === "2" || rawVal === 2) return "USB secondary ethernet";
                if (rawVal === "" ) return "primary ethernet"

              }
              return rawVal;
            }
          );

          const timeSinceTriggered =
            event.triggered &&
            event.timeExecutedInEpoch &&
            formatDistanceToNow(new Date(event.timeExecutedInEpoch * 1000), {
              addSuffix: true,
            });

          const timeSinceSync = event.lastChange ? formatDistanceToNow(new Date(event.lastChange)) : ""

          const rowOpacity = event.stale
            ? 0.45
            : event.connectionState === "Connected"
            ? 1
            : 0.6;

          return (
            <div
              key={index} className="grid-row-wrapper"
              style={{
                opacity: rowOpacity,
              }}
            >
              <div className="grid-row" style={{}}>
                <div
                  style={{
                    flex: columnWidths[1],
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "center",
                  }}
                >
                  <Link
                    to={`/devices/connected/${event.enclosureSerialNumber}/alerts/${event.id}`}
                  >
                    <React.Fragment>
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          justifyContent: "center",
                        }}
                      >
                      <span
                        style={{
                          fontWeight: "600",
                          textDecoration: "underline",
                        }}
                      >
                        {event.name}
                      </span>
                      {event.stale ? (
                        <span
                          style={{
                            marginTop: "4px",
                            fontSize: "12px",
                            color: "#7f8c8d",
                          }}
                        >
                          Snapshot from {timeSinceSync || "previous sync"}
                        </span>
                      ) : null}
                    </span>
                    <span style={{}}>
                      <span
                        style={{
                          display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span>{eventRefName}</span>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          ></span>
                        </span>
                      </span>
                    </React.Fragment>
                  </Link>
                </div>

                <div
                  style={{ flex: columnWidths[2] }}
                  title={event.triggered ? "ALERT" : "OK"}
                >
                  <div
                    className="spreadsheet-badge"
                    style={{
                      backgroundColor: event.triggered
                        ? "rgb(235 210 210)"
                        : "rgb(194, 223, 194)",
                    }}
                  >
                    <i
                      className="material-icons"
                      style={{
                        color: event.triggered ? "maroon" : "forestgreen",
                        marginRight: "0px",
                      }}
                    >
                      {event.triggered ? "circle_notifications" : "task_alt"}
                    </i>
                    <b className="show-for-large-only">
                      {event.triggered ? "Alert" : " OK  "}
                    </b>
                  </div>
                </div>
                <div
                  style={{
                    flex: columnWidths[6],
                    display: "flex",
                    // alignItems: "center",
                  }}
                >
                  {timeSinceTriggered}
                </div>
                <div
                  style={{
                    flex: columnWidths[7],
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>{hydratedFoundEventRefDesc}</span>
                    {event.stale ? (
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#95a5a6",
                          marginTop: "4px",
                        }}
                      >
                        {offlineReason || "Last synced while the device was offline."}
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

const Loading = ({ columnWidths }) => {
  return (
    <div style={{}}>
      {[null, null, null, null].map((item, index) => {
        return (
          <div className="grid-row-wrapper" key={index}>
            <div className="grid-row">
              {/* <div style={{ flex: columnWidths[0] }}></div> */}
              <div style={{ flex: columnWidths[1] }}>
                <div className="skeleton-blank" />
              </div>
              <div style={{ flex: columnWidths[2] }}>
                <div className="skeleton-blank" />{" "}
              </div>
              {/* <div style={{ flex: columnWidths[3] }}>
                <div className="skeleton-blank" />{" "}
              </div> */}
              <div style={{ flex: columnWidths[4] }}>
                <div className="skeleton-blank" />
              </div>
              <div style={{ flex: columnWidths[5] }}>
                <div className="skeleton-blank" />
              </div>
              {/* <div style={{ flex: columnWidths[6] }}>
                <div className="skeleton-blank" />{" "}
              </div> */}
              <div style={{ flex: columnWidths[7] }}>
                <div className="skeleton-blank" />
              </div>
              {/* <div style={{ flex: columnWidths[8] }}>
              <div className="skeleton-blank" />
            </div> */}
              {/* <div style={{ flex: columnWidths[9] }}>
                <div className="skeleton-blank" />{" "}
              </div> */}
            </div>
          </div>
        );
      })}
    </div>
  );
};
